import { parallax } from '../utils/animation';

const hero = {
	elements: {
		$hero: $('.js-hero'),
	},

	init() {
		parallax(this.elements.$hero);
	},
}

export default hero
